import { Pipe, PipeTransform } from "@angular/core";
import { timeAgo } from "apps/merchant-portal/src/modules/shared/utils/date.util";

@Pipe({
  name: "timeAgo",
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string | number): string {
    const date = new Date(value);
    return timeAgo(date);
  }
}
